import { createFileRoute } from "@tanstack/react-router"

import { ScheduledJobsPanel } from "@/pages/ScheduledJobsPanel"

export const Route = createFileRoute("/administration/jobs")({
  component: ScheduledJobsPanel,
})
